// Frameworks
import { Box } from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
// Styles
import { chipLabelBoxSx, chipLabelIconSx } from '../TableMotoristasFilters.styles'

/**
 * ChipLabel Component
 * @description A component that displays a label with an icon indicating the number of filters applied. It is used in the timesheet filters to provide a visual indication of active filters.
 * @param {number} filterCount - The number of filters currently applied.
 * @returns {JSX.Element} The rendered ChipLabel component.
 */
export const ChipLabel = ({ filterCount }: { filterCount: number }) => (
	<Box sx={chipLabelBoxSx}>
		<FilterAltIcon
			fontSize='small'
			sx={chipLabelIconSx}
		/>
		<span>
			{filterCount} Filtro{filterCount !== 1 && 's'} Aplicado
			{filterCount !== 1 && 's'}
		</span>
	</Box>
)
